import { render, staticRenderFns } from "./advertise.vue?vue&type=template&id=8874996a&scoped=true&"
import script from "./advertise.vue?vue&type=script&lang=js&"
export * from "./advertise.vue?vue&type=script&lang=js&"
import style0 from "./advertise.vue?vue&type=style&index=0&id=8874996a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8874996a",
  null
  
)

export default component.exports